import { campaignHu } from './hu/campaign_lang';
import { campaignEn } from './en/campaign_lang';

export type CampaignLang = typeof campaignHu;

export const getCampaignLang = (language: string): CampaignLang => {
  return language === 'en' || language === 'English' ? campaignEn : campaignHu;
};
